export default "__VITE_ASSET__d603a56c__"